import styled from 'styled-components';

import { COLORS } from '@r1-frontend/ui-react/tokens/colors';

export const CostWrapper = styled.div`
    display: inline-block;
    color: inherit;
    white-space: nowrap;
`;

export const PreviousCost = styled.s`
    text-decoration-color: ${COLORS.TextInfo};
    color: ${COLORS.TextInfo};
`;
